module.exports = __webpack_public_path__ + "static/media/edmar_de_queiroz_figueiredo.cf329c79.jpg";